import { Pipe, PipeTransform } from "@angular/core";
import { GateSystemRef } from "../../../models/shared/refs";

@Pipe({
  name: "gateIdentifier",
  standalone: true,
})
export class GateIdentifierPipe implements PipeTransform {
  // private permissions = inject(PermissionService);

  transform(value: GateSystemRef, fullPermission: boolean): string {
    let gateIdentifier = "";

    if (value.location?.label && value.building?.label && value.label) {
      if (fullPermission) {
        gateIdentifier = value.customer?.label
          ? `${value.customer.label} / ${value.location.label} / ${value.building.label} / ${value.label}`
          : `${value.location.label} / ${value.building.label} / ${value.label}`;
      } else {
        gateIdentifier = `${value.location.label} / ${value.building.label} / ${value.label}`;
      }
    }

    return gateIdentifier;
  }
}
